import BadgeProductsTableActionsMenu from "../actions-menu/BadgeProductsTableActionsMenu"

const BadgeProductsTableRow = ({row: product, checkBoxComponent, actionOverlay, hasWritePermission}: any) => {
  return (
    <tr>
      {checkBoxComponent && <td>{checkBoxComponent(product)}</td>}
      <td>{product?.sku}</td>
      <td>{product?.name}</td>
      <td>{product?.category}</td>
      <td>{product?.brand}</td>
      {hasWritePermission && actionOverlay && actionOverlay(BadgeProductsTableActionsMenu)}
    </tr>
  )
}

export default BadgeProductsTableRow
